import { elapsed, timeStampNow } from '@datadog/browser-core';
import { serializeNodeWithId } from './serializeNode';
import { updateSerializationStats } from './serializationStats';
export function serializeDocument(document, configuration, scope, serializationContext) {
    const serializationStart = timeStampNow();
    const serializedNode = serializeNodeWithId(document, configuration.defaultPrivacyLevel, {
        serializationContext,
        configuration,
        scope,
    });
    updateSerializationStats(serializationContext.serializationStats, 'serializationDuration', elapsed(serializationStart, timeStampNow()));
    // We are sure that Documents are never ignored, so this function never returns null
    return serializedNode;
}
//# sourceMappingURL=serializeDocument.js.map